import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/api";

export const useGoTo = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (id) => {
    if (pathname === "/" && scrollToId(id)) return;
    navigate(`/#${id}`);
  };
};
